import { render, staticRenderFns } from "./ToothAddDialog.vue?vue&type=template&id=764e7bcb&scoped=true&"
import script from "./ToothAddDialog.vue?vue&type=script&lang=js&"
export * from "./ToothAddDialog.vue?vue&type=script&lang=js&"
import style0 from "./ToothAddDialog.vue?vue&type=style&index=0&id=764e7bcb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764e7bcb",
  null
  
)

export default component.exports